import React from "react";
import * as MarkdownItTexMath from "markdown-it-texmath";
import { StyleSheet } from "react-native";
// TODO: Make Katex async again once expo/webpack-config supports webpack@5
import _katex from "katex";
import "../../../assets/katex.css";
// let _katex: typeof import("katex") | null = null;
export async function addLatexSupport(markdownIt) {
    if (!_katex) {
        // _katex = await import("katex");
        // @ts-ignore
        // await import("katex/dist/katex.css");
    }
    markdownIt.use(MarkdownItTexMath.use(_katex));
}
export const renderInlineMath = (node) => {
    let output;
    try {
        output = _katex.renderToString(node.content, { displayMode: false });
    }
    catch (error) {
        output = error instanceof Error ? error.message : String(error);
    }
    return (<div style={{ display: "inline", fontSize: "83%" }} dangerouslySetInnerHTML={{
            __html: output,
        }}/>);
};
export const renderBlockMath = (node, _children, _parent, styles, inheritedStyles = {}) => {
    let output;
    try {
        output = _katex.renderToString(node.content, { displayMode: true });
    }
    catch (error) {
        output = error instanceof Error ? error.message : String(error);
    }
    return (<div style={StyleSheet.flatten(styles.math_block)} dangerouslySetInnerHTML={{
            __html: output,
        }}/>);
};
//# sourceMappingURL=markdownLatexSupport.web.js.map